import { render } from "./ContainerShell.vue?vue&type=template&id=44afcc54"
import script from "./ContainerShell.vue?vue&type=script&lang=js"
export * from "./ContainerShell.vue?vue&type=script&lang=js"

import "./ContainerShell.vue?vue&type=style&index=0&id=44afcc54&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__